<template>
  <v-app id="inspire">
    <router-view name="navbar"></router-view>
    <v-content v-if="loaded && socketConnected">
      <v-container class="fill-height" fluid>
        <router-view></router-view>
        <router-view name="footer"></router-view>
      </v-container>
    </v-content>
    <v-content v-else>
      <LoadingScreen />
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoadingScreen from "./components/LoadingScreen.vue";

export default {
  components: { LoadingScreen },
  props: {
    source: String
  },
  data: () => ({
    drawer: null,
    drawerRight: null,
    left: true,
    code: ""
  }),
  computed: {
    ...mapState("tasks", ["loaded"]),
    ...mapState(["socketConnected"])
  },
  watch: {
    socketConnected(newValue) {
      if (newValue) {
        this.loadServerAdress();
        this.loadTaskSolved({ wm: this });
        this.register();
        if ('key' in this.$route.query) {
          this.$store.state.key = this.$route.query.key;
          this.authenticate({ key: this.$store.state.key });
        }
      }
    },
    $route (to, _){
      this.$store.commit('SIMPLE_SEND', {
        type: 'WS_CHANGE',
        path: to.path
      });
    }
  },
  methods: {
    ...mapActions("game", ["register", "authenticate"]),
    ...mapActions("user", [
      "loadTaskSolved",
    ]),
    ...mapActions("settings", ["loadServerAdress"])
  },
  beforeCreate() {
    this.$connect();
    this.$store.dispatch("tasks/loadTasks");
    this.$store.dispatch("settings/loadServerAdress");
  }
};
</script>
